import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../api/axios';

const ConfigContext = createContext();

const DEFAULT_CONFIG = {
    primaryColor: '#1e40af',
    secondaryColor: '#1e293b',
    logoUrl: '',
    buttonStyles: { borderRadius: '12px', padding: '12px 24px' },
    pages: { agenda: true, speakers: true, streaming: true },
    pageDesigns: {},
    event_letters: {},
    registration_fields: {
        identification: true,
        name: true,
        last_name: true,
        email: true,
        city: true,
        country: true,
        signature_by_date: false
    }
};

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(DEFAULT_CONFIG);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const [visualRes, pagesRes, customRes, designsRes, lettersRes, regRes] = await Promise.all([
                    api.get('/configs/visual_identity'),
                    api.get('/configs/page_controls'),
                    api.get('/configs/custom_gallery_pages'),
                    api.get('/configs/page_designs'),
                    api.get('/configs/event_letters'),
                    api.get('/configs/registration_fields')
                ]);
                
                const newConfig = {
                    ...(visualRes.data || {
                        primaryColor: '#1e40af',
                        secondaryColor: '#1e293b',
                        logoUrl: '',
                        buttonStyles: { borderRadius: '12px', padding: '12px 24px' }
                    }),
                    pages: pagesRes.data || { agenda: true, speakers: true, streaming: true },
                    customGalleryPages: customRes.data || [],
                    pageDesigns: designsRes.data || {},
                    event_letters: lettersRes.data || {},
                    registration_fields: regRes.data || { identification: true, name: true, last_name: true, email: true, city: true, country: true, signature_by_date: false }
                };
                
                // Inject fonts to DOM
                if (newConfig.fontFamily) {
                    document.documentElement.style.setProperty('--main-font', `"${newConfig.fontFamily}", sans-serif`);
                }
                if (newConfig.secondaryFontFamily) {
                    document.documentElement.style.setProperty('--secondary-font', `"${newConfig.secondaryFontFamily}", sans-serif`);
                }

                setConfig(prev => JSON.stringify(prev) === JSON.stringify(newConfig) ? prev : newConfig);
            } catch (error) {
                console.error("Config fetch failed, using defaults", error);
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
        const interval = setInterval(fetchConfig, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <ConfigContext.Provider value={{ config, loading }}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);
